import { Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function PDFErrorState({ error, onClose }) {
  return (
    <div className="flex flex-col items-center justify-center h-full min-h-[400px] animate-fade-in p-8">
      <Loader2 className="w-12 h-12 animate-spin text-red-500 mb-4" />
      <h3 className="text-lg font-semibold text-foreground mb-2">Loading PDF...</h3>
      <p className="text-muted-foreground text-center mb-4">Still trying to load the PDF. If this takes too long, please check your connection or try again later.</p>
      <p className="text-red-400 text-center mb-2">{error}</p>
      {onClose && (
        <Button onClick={onClose} variant="outline">
          Go Back
        </Button>
      )}
    </div>
  );
}
